import axios from 'axios';
import jwtDecode from 'jwt-decode';

const apiUrl = process.env.GATSBY_API_URL;

export const emailLookup = async (email) => {
  const { data } = await axios.get(`${apiUrl}/clearbit/${email}`);
  return data;
};

export const decodeJwt = (jwt) => jwtDecode(jwt);

export const createUser = async (userData) => {
  const res = await axios.post(`${apiUrl}/user`, userData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data;
};

export const getUser = async (jwt) => {
  const id = decodeJwt(jwt).sub;
  const res = await axios.get(`${apiUrl}/user/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${jwt}`,
    },
  });
  return res.data;
};

export const addBookmark = async (jwt, bookmarkData) => {
  const id = decodeJwt(jwt).sub;
  const res = await axios.post(`${apiUrl}/user/${id}/bookmark`, bookmarkData, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${jwt}`,
    },
  });
  return res.data;
};

export const deleteBookmark = async (jwt, data) => {
  const id = decodeJwt(jwt).sub;
  const res = await axios.delete(`${apiUrl}/user/${id}/bookmark`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${jwt}`,
    },
    data,
  });
  return res.data;
};

export const updateUser = async (jwt, { user_id: userId, picture, displayName, ...userData }) => {
  const id = decodeJwt(jwt).sub;
  const res = await axios.put(`${apiUrl}/user/${id}`, userData, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${jwt}`,
    },
  });
  return res.data;
};

export const stLogin = async (jwt) => {
  const res = await axios.post(
    `${apiUrl}/user/stlogin`,
    { jwt },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return res.data;
};

export const forgotPassword = async (email) => {
  const res = await axios.post(`${apiUrl}/user/forgotPassword/${email}`);
  return res.data;
};
